import React from "react";

export default function Portfolio() {
  const projects = [
    {
      name: "Point of Sale (POS) System",
      category: "pos",
      description:
        "Manage sales, inventory, and transactions efficiently in real-time.",
      tags: "POS • Inventory • Sales",
      video: "https://www.youtube.com/embed/MWEID7Io39s",
      title: "POS System Demo 1",
      delay: 0,
    },
    {
      name: "Point of Sale (POS) System",
      category: "pos",
      description: "A complete POS overview with touch-based & manual sales.",
      tags: "POS • Inventory • Sales",
      video: "https://www.youtube.com/embed/gTiGXKNYYEE",
      title: "POS System Demo 2",
      delay: 60,
    },
    {
      name: "Modern Custom ERP/POS",
      category: "pos",
      description:
        "All-in-one ERP for inventory, accounts, and sales with real-time control.",
      tags: "ERP • POS • Inventory",
      video: "https://www.youtube.com/embed/6unp9xeoQMQ",
      title: "ERP/POS Demo",
      delay: 120,
    },
    {
      name: "Pharmacy Inventory Management",
      category: "inventory",
      description:
        "Manage stock, track inventory, and generate real-time reports for pharmacies.",
      tags: "Inventory • Pharmacy",
      video: "https://www.youtube.com/embed/wmhvfZ13V-A",
      title: "Inventory Demo",
      delay: 0,
    },
    {
      name: "School Management System",
      category: "school",
      description:
        "Manage student records, attendance, grades, and staff-parent communication.",
      tags: "School • Management",
      video: "https://www.youtube.com/embed/d1XLbfHnE2o",
      title: "School Management Demo",
      delay: 60,
    },
    {
      name: "Ecommerce Inventory App",
      category: "inventory",
      description:
        "Streamline inventory, orders, and customer data for online stores.",
      tags: "Ecommerce • Inventory",
      video: "https://www.youtube.com/embed/XoD6Vnp8U8c",
      title: "Ecommerce Inventory Demo",
      delay: 120,
    },
  ];

  return (
    <section id="portfolio" className="section my-5">
      <div className="container">
        {/* Section Header + Filters */}
        <div className="d-flex align-items-center justify-content-between mb-3 flex-wrap gap-2">
          <h2 className="section-title h1 fw-bold m-0" data-aos="fade-right">
            <i className="bi bi-rocket-takeoff me-2"></i>Selected Work
          </h2>
          <div className="btn-group" role="group" aria-label="Filter">
            <button
              className="btn btn-outline-dark btn-sm active"
              data-filter="*"
            >
              All
            </button>
            <button className="btn btn-outline-dark btn-sm" data-filter=".pos">
              POS
            </button>
            <button
              className="btn btn-outline-dark btn-sm"
              data-filter=".inventory"
            >
              Inventory
            </button>
            <button
              className="btn btn-outline-dark btn-sm"
              data-filter=".school"
            >
              School
            </button>
          </div>
        </div>

        {/* Portfolio Items */}
        <div className="row g-4 portfolio">
          {projects.map((project, index) => (
            <div
              key={index}
              className={`col-md-6 col-lg-4 portfolio-item ${project.category}`}
              data-aos="fade-up"
              data-aos-delay={project.delay}
            >
              <div className="work-card card-soft">
                <iframe
                  width="100%"
                  height="200"
                  src={project.video}
                  frameBorder="0"
                  allowFullScreen
                  title={project.title}
                ></iframe>
                <div className="work-overlay">
                  <div>
                    <div className="small text-dark-50">{project.tags}</div>
                    <h5 className="fw-bold">{project.name}</h5>
                    <p className="small text-dark-50">{project.description}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
